import { combineReducers } from "redux";
import { ACTION } from "./constants";

let initialState = {};

export default function InvesterServicesReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION.INVESTOR_FORM_LIST:
      return { ...state, investorSevicesForm: action.data };
    case ACTION.NOTICES_AGENDA_LIST:
      return { ...state, noticeAgenda: action.data };
    case ACTION.ADD_INFO_LIST:
      return { ...state, additionainfo: action.data };
    case ACTION.FUND_LITERATURE_LIST:
      return { ...state, documentLiteratureList: action.data };
    case ACTION.INVESTOR_LANDING_PAGE:
      return { ...state, landingpageinfo: action.data };
    case ACTION.INVESTOR_GENERAL_FAQ:
      return { ...state, generalFaq: action.data };
    case ACTION.INVESTOR_MARKET:
      return { ...state, investormarket: action.data };
    case ACTION.FUND_LITERATURE_DATA:
      return { ...state, fundlitrature: action.data };
    case ACTION.FACTSHEET:
      return { ...state, factsheet: action.data };
    case ACTION.FACTSHEET_MONTH:
      return { ...state, factsheetmonth: action.data, apiLoaded: true };
    case ACTION.ADDITIONAL_FUND_INFO:
      return { ...state, additionalfundinfo: action.data };
    case ACTION.FUND_DOCUMENT_FILTER_LIST:
      return { ...state, fundDocumentFilterData: action.data };
    case ACTION.OUR_ONLINE_SERVICES:
      return { ...state, ourOnlineServices: action.data };
    case ACTION.AGENDA_MONTH:
      return { ...state, agendamonth: action.data, apiLoaded: true };
    case ACTION.GET_SCHEME_ACCOUNT_FILTER :
      return {...state, ...action.data};
    case ACTION.GET_SCHEME_ACCOUNT_CONTENT :
      return {...state, files:{...action.data}}; 
    case ACTION.CLEAR_FUND_LITERATURE_LIST:
      return { ...state, documentLiteratureList: {} };
    case ACTION.GET_MARKET_VIDEO_DETAILS:
      return { ...state, marketVideoDetailData: action.data };
    case ACTION.GET_PORTFOLIO_DATA:
      return { ...state, ourWeeklyPortfolioData: action.data };

    default:
      return state;
  }
}
